import 'css-chunksrc/client/scenes/addIdentityProvider/form/casForm/protocolSelect/styles.scss';export default {
  "protocolSelect": "_protocolSelect_1bvcs_1",
  "input": "_input_1bvcs_5",
  "name": "_name_1bvcs_16",
  "iconBox": "_iconBox_1bvcs_22",
  "icon": "_icon_1bvcs_22",
  "open": "_open_1bvcs_37",
  "listRoot": "_listRoot_1bvcs_45",
  "list": "_list_1bvcs_45",
  "item": "_item_1bvcs_63"
};